import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import Button from '../../elements/Button';
import content from './content';
import canadaFlag from './../../../../static/img/canada_flag.png'
import usFlag from './../../../../static/img/us_flag.png'

import './style.scss';

function DropdownItem(props) {
    const { header, link, text, icon, sub_links } = props;

    return (
        <div className="row g-0 cb-nav-dropdown-item" id={header}>
            <div className="nav-icon col-2">
                <img loading='lazy' src={icon} alt="icon" />
            </div>
            <div className="item-content col-10">
                {link && (
                    <a href={link}>
                        <h5>{header}</h5>
                        <p>{text}</p>
                    </a>
                )}
                {!link && (
                    <a>
                        <h5>{header}</h5>
                        <p>{text}</p>
                    </a>
                )}
                {sub_links && (
                    <ul className="sub-links row g-0">
                        {sub_links.map((sub_link, i) => {
                            return (
                                <li className="col-6" key={i}>
                                    <a href={sub_link.link}>{sub_link.text}</a>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
}

const LanguageFlipper = ({ locale, path, mobile }) => {
    /**
     * This isn't working in production. Need to spend time later to diagnose.
     * For now, hardcode the links to the index page.
     */
    // let frenchPath = path;
    // let englishPath = path;

    // if (locale === 'en-ca') {
    //     frenchPath = path.toString().replace('en-ca', 'fr-ca')
    // } else if (locale === 'fr-ca') {
    //     englishPath = path.toString().replace('fr-ca', 'en-ca')
    // }

    let c_lang, c_flag;

    if(locale == '' || locale =='en-us'){
        c_lang = 'EN';
        c_flag = usFlag;

    }else if(locale == 'en-ca'){
        c_lang = 'EN';
        c_flag = canadaFlag;
    }else if(locale == 'fr-ca'){
        c_lang = 'FR';
        c_flag = canadaFlag;
    }

    const [languageSelect, setLanguageSelect] = useState(c_lang);
    const [country_flag, setCountry_flag] = useState(c_flag);

    const setLanguageOverride = language => {
        localStorage.setItem('checkbook-language-override', language);
        if(language === 'en-us'){
            localStorage.removeItem('checkbook-language-override')
            setLanguageSelect('EN');
            setCountry_flag(canadaFlag);
        }else if(language === 'en-ca'){
            setLanguageSelect('EN');
            setCountry_flag(canadaFlag);
        }else if(language === 'fr-ca'){
            setLanguageSelect('FR');
            setCountry_flag(canadaFlag);
        }
    };

    if (mobile) {
        return (
            <>
                {locale == 'fr-ca' && (
                    <span onClick={() => setLanguageOverride('en-ca')}>
                        <a href="/en-ca/">Switch to English site</a>
                    </span>
                )}
                {locale == 'en-ca' && (
                    <span onClick={() => setLanguageOverride('fr-ca')}>
                        <a href="/fr-ca/">Switch to French site</a>
                    </span>
                )}
            </>
        );
    }

    return (
        <div className="language-flipper">
            <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <span>
                        <img className='country_flag' src={c_flag} alt='Country'/>
                        {languageSelect}

                    </span>

                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <span onClick={() => setLanguageOverride('en-ca')}>
                    <Dropdown.Item href="/en-ca/"><img className='country_flag' src={canadaFlag} alt='Country'/>EN</Dropdown.Item>
                    </span>
                    <span onClick={() => setLanguageOverride('fr-ca')}>
                        <Dropdown.Item href="/fr-ca/" ><img className='country_flag' src={canadaFlag} alt='Country'/>FR</Dropdown.Item>
                    </span>
                    <span onClick={() => setLanguageOverride('en-us')}>
                        <Dropdown.Item href="/"><img className='country_flag' src={usFlag} alt='Country'/>EN</Dropdown.Item>
                    </span>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

function CheckbookNavbar({ style, locale = '' }) {
    const checkbook_logo_link = locale === '' ? '/' : '/' + locale + '/';
    const navItems =
        locale === ''
            ? content['navItems']
            : content[locale.replace('-', '') + '_navItems'];
    const currentPath =
        typeof window !== 'undefined' && window.location.pathname;

    const [state, setState] = useState({
        expand: false,
        dropdowns: {
            products_expand: false,
            solutions_expand: false,
            company_expand: false,
        },
    });

    const toggleNavbarExpand = () => {
        setState({
            expand: state.expand ? false : true,
            dropdowns: {
                products_expand: state.dropdowns.products_expand,
                solutions_expand: state.dropdowns.products_expand,
                company_expand: state.dropdowns.company_expand,
            },
        });
    };
    const bannerStyle = {
        width: "100%",
        backgroundColor: "#ffffff",
        color: "#000000",
        padding: "0.5rem",
        textAlign: "center",
      };

    return (
        
        
        <nav
            className={`cb-navbar ${state.expand ? 'white-bg-mobile' : ''} ${
                style == 'white' ? 'white' : ''
            }`}
        >
            <div className="navbar-wrapper row g-0">
                <div className="navbar-header col-12 col-xl-3 row g-0 align-items-center">
                    <div className="nav-logo col-4">
                        <a href={checkbook_logo_link}>
                            <img
                                loading='lazy'
                                alt="logo"
                                src={
                                    state.expand || style == 'white'
                                        ? '/img/checkbook_logo_blue.png'
                                        : '/img/checkbook_logo_white.png'
                                }
                            />
                        </a>
                    </div>
                    <div
                        className="nav-toggle ms-auto"
                        onClick={toggleNavbarExpand}
                    ></div>
                </div>

                <ul
                    className={`nav-list col-12 col-xl-6 row g-0 justify-content-center ${
                        state.expand ? 'show' : ''
                    }`}
                >
                    {navItems.map((navItem, i) => {
                        return (
                            <li
                                className="primary-link col-12 col-xl-2 row g-0 align-items-center"
                                key={i}
                            >
                                {navItem.link && (
                                    <a href={navItem.link}>{navItem.name}</a>
                                )}
                                {!navItem.link && <a>{navItem.name}</a>}
                                {navItem.desktopDropdown && (
                                    <ul className="nav-dropdown row g-0">
                                        {navItem.desktopDropdown.map(
                                            (dropdownItem, i) => {
                                                return (
                                                    <li
                                                        className="dropdown-link col-12"
                                                        key={i}
                                                    >
                                                        <DropdownItem
                                                            {...dropdownItem}
                                                        />
                                                    </li>
                                                );
                                            }
                                        )}
                                    </ul>
                                )}
                                {navItem.mobileDropdown && (
                                    <ul className="nav-dropdown-mobile col-12 row g-0">
                                        {navItem.mobileDropdown.map(
                                            (dropdownItem, i) => {
                                                return (
                                                    <li
                                                        className="dropdown-mobile-link col-6 col-md-4 col-lg-3"
                                                        key={i}
                                                    >
                                                        <a
                                                            href={
                                                                dropdownItem.link
                                                            }
                                                        >
                                                            {dropdownItem.text}
                                                        </a>
                                                    </li>
                                                );
                                            }
                                        )}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                    <li
                        className="primary-link col12 col-xl-3"
                        id="sign-in-link"
                    >
                        <a href="https://app.checkbook.io/login">Sign in</a>
                    </li>
                    {/* disable for Galileo compliance, re-enable if we get translations certified */}
                    {/* <li className="primary-link col12 col-xl-3 mobile-language-flipper">
                        <LanguageFlipper
                            locale={locale}
                            path={currentPath}
                            mobile={true}
                        />
                    </li> */}
                </ul>

                <div className="sign-in-button g-0 col-xl-3 justify-content-end align-items-center">
                    {/* disable for Galileo compliance, re-enable if we get translations certified */}
                    {/* <LanguageFlipper locale={locale} path={currentPath} /> */}
                    <Button src="https://app.checkbook.io/account" value="Sign In" />
                </div>
            </div>
        </nav>
    );
}

export default CheckbookNavbar;
